import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["global", "countrySelect"]

  connect () {
    this.toggle();
  };

  toggle() {
    if(this.globalTarget.checked) {
      this.countrySelectTarget.classList.add('hidden');
    } else {
      this.countrySelectTarget.classList.remove('hidden');
    }
  }
}
